import {computed, override} from "mobx";
import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {OddsByWidgetConfig} from "../odds-by-widget.config";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {BookmakerViewModel} from "../../../domain/common/bookmaker/models/bookmaker-view-model";
import {DUMMY_BOOKIE_ID} from "../../../core/components/odds/components/odds-consts";

export class OddsByWidgetState extends BaseModuleState {

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, OddsByWidgetConfig];

  @override get isPopulated(): Boolean {
    return (this.topBookmaker?.id !== DUMMY_BOOKIE_ID) && (this.topBookmaker?.id > 0);
  }

  @computed get topBookmaker(): Boolean {
    return this.appState.topBookmaker;
  }

  @computed get bookmaker(): BookmakerViewModel {
    return this.topBookmaker?.id > 0 && this.topBookmaker?.id !== DUMMY_BOOKIE_ID && new BookmakerViewModel(this.topBookmaker);
  }

  @computed get cardTitle(): String {
     return this.terms.WEB_ODDS_BY.format({
       "Bookmaker": this.bookmaker.name
     });
  }

  get source() {
    return this.config.source;
  }

  get buttonText() {
    return this.terms.WEB_CLAIM_NOW;
  }

  get text(): String {
    return this.bookmaker?.offerText ? this.bookmaker?.offerText : this.bookmaker?.promotionText || this.terms.WEB_ODDS_BY_FALLBACK_TEXT;
  }

  get buttonLink(): String {
    return this.bookmaker?.offerUrl ? this.bookmaker?.offerUrl : this.bookmaker?.link;
  }

  @computed get shouldRenderWidget(): Boolean {
    return this.topBookmaker?.id !== DUMMY_BOOKIE_ID && this.topBookmaker?.id > 0 && this.text;
  }

}
